import React from 'react';
import { Stack, Typography } from '@mui/material';
import { QualifyingQuestionScorecard } from '../QuestionsGroup/QualifyingQuestionScorecard';
import { PreferredAnswerRequirementsList } from 'common/ui';

type QualifyingQuestionViewProps = {
  content: string;
  preferredAnswerText: string | null | undefined;
  onRequirementsGenerated?: (requirements: string[]) => void;
  preferredAnswerRequirements?: string[] | null;
};

export const QualifyingQuestionView: React.FC<QualifyingQuestionViewProps> = ({
  content,
  preferredAnswerText,
  preferredAnswerRequirements,
  onRequirementsGenerated
}) => {
  const hasPreferredAnswer = !!preferredAnswerText;

  return (
    <Stack gap="10px" flex="1">
      <Typography variant="captions">Question</Typography>
      <Typography variant="summary">{content}</Typography>
      {hasPreferredAnswer && (
        <>
          <Typography
            sx={{
              mt: '20px',
              mb: '8px'
            }}
          >
            Preferred answer:
          </Typography>
          <Typography>{preferredAnswerText}</Typography>
          <Typography
            sx={{
              mt: '10px'
            }}
          >
            Scorecard:
          </Typography>
          {onRequirementsGenerated ? (
            <QualifyingQuestionScorecard
              initialValues={{
                content,
                preferredAnswerText: preferredAnswerText || ''
              }}
              onRequirementsGenerated={onRequirementsGenerated}
            />
          ) : (
            <PreferredAnswerRequirementsList
              requirements={preferredAnswerRequirements || []}
            />
          )}
        </>
      )}
    </Stack>
  );
};
